<template>
  <div class="content" id="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    ></BlockUI>
    <v-card>
      <v-card-title>
        Faturamento Detalhado
        <v-spacer></v-spacer>
        <v-flex xs1>
          <v-btn
            class="btn-block btn btn-secondary mb-2"
            @click="setFullScreen()"
          >
            <v-icon small class="black--text">fullscreen</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <v-flex xs3>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Procurar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs1>
          <v-text-field
            prepend-icon="event"
            label="Data Inicial"
            v-mask="'####/##/##'"
            v-model="initialDate"
            @blur="validateDate(initialDate)"
          />
        </v-flex>
        <v-flex xs1>
          <v-text-field
            prepend-icon="mdi-clock"
            label="Hora Inicial"
            v-mask="'##:##:##'"
            v-model="initialHour"
            @blur="validateHour(initialHour)"
          />
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs1>
          <v-text-field
            prepend-icon="event"
            label="Data Final"
            v-mask="'####/##/##'"
            v-model="finalDate"
            @blur="validateDate(finalDate)"
          />
        </v-flex>
        <v-flex xs1>
          <v-text-field
            prepend-icon="mdi-clock"
            label="Hora Final"
            v-mask="'##:##:##'"
            v-model="finalHour"
            @blur="validateHour(finalHour)"
          />
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2>
          <v-btn
            class="btn-block btn btn-primary mb-2 filtro-button"
            @click="filtrar()"
            >Filtrar</v-btn
          >
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-flex sm6 offset-sm10 offset-lg10>
        <download-excel
          class="ml-auto mr-0"
          :data="reservationGrid"
          :fields="json_fields"
          name="faturamento_detalhado.xls"
        >
          <v-btn small class="mr-4"
            ><span class="pr-1">Exportar</span
            ><v-icon small class="black--text">insert_drive_file</v-icon></v-btn
          >
        </download-excel>
      </v-flex>
      <br />
      <v-data-table
        id="table"
        footer-props.items-per-page-text="Linhas por página"
        no-data-text="nenhum dado encontrado"
        :headers="headers"
        :items="reservationGrid"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class>{{ item.name }}</td>
            <td class>{{ item.mobilizacao }}</td>
            <td class>{{ item.desmobilizacao }}</td>
            <td class>{{ item.placa }}</td>
            <td class>{{ item.rec_assinatura | formatValue }}</td>
            <td class>{{ item.rec_pacote | formatValue }}</td>
            <td class>{{ item.rec_avulsa | formatValue }}</td>
            <td class>{{ item.rec_extensao | formatValue }}</td>
            <td class>{{ item.rec_km | formatValue }}</td>
            <td class>{{ item.rec_captura_manual | formatValue }}</td>
            <td class>{{ item.rec_carteira | formatValue }}</td>
            <td class>{{ item.total | formatValue }}</td>
            <td class>{{ item.vlr_estorno | formatValue }}</td>
            <td class>{{ item.rec_multa_transito | formatValue }}</td>
            <td class>{{ item.rec_sinistro | formatValue }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import TransactionController from '../../controllers/TransactionController';
import moment from 'moment';
import Roles from '../../models/Roles';
import { format } from 'date-fns';

export default {
  data() {
    return {
      profile: localStorage.getItem('profile'),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      header_color: 'blue',
      initialHour: '00:00:00',
      initialDate: moment()
        .startOf('month')
        .format('YYYY/MM/DD'),
      finalHour: '23:59:59',
      finalDate: moment()
        .endOf('month')
        .format('YYYY/MM/DD'),
      initialDateTime: '',
      finalDateTime: '',
      reservationGrid: [],
      service: null,
      search: '',
      headers: [
        { text: 'Condomínio', value: 'name' },
        { text: 'Mobilização', value: 'mobilizacao' },
        { text: 'Desmobilização', value: 'desmobilizacao' },
        { text: 'Placa', value: 'placa' },
        { text: 'Valor em Assinatura', value: 'rec_assinatura' },
        { text: 'Valor em Pacotes', value: 'rec_pacote' },
        { text: 'Valor em Avulsa', value: 'rec_avulsa' },
        { text: 'Valor em Extensão', value: 'rec_extensao' },
        { text: 'Valor em KM', value: 'rec_km' },
        { text: 'Outros', value: 'rec_captura_manual' },
        { text: 'Valor Uso Wallet', value: 'rec_carteira' },
        { text: 'Receita com Locações', value: 'total' },
        { text: 'Estornos Anteriores', value: 'vlr_estorno' },
        { text: 'Reembolso Multa de Trans.', value: 'rec_multa_transito' },
        { text: 'Reembolso Sinistro', value: 'rec_sinistro' },
      ],
      json_fields: {
        Condomínio: 'name',
        Mobilização: 'mobilizacao',
        Desmobilização: 'desmobilizacao',
        Placa: 'placa',
        'Valor em Assinatura': {
          field: 'rec_assinatura',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'Valor em Pacotes': {
          field: 'rec_pacote',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'Valor em Avulsa': {
          field: 'rec_avulsa',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'Valor em Extensão': {
          field: 'rec_extensao',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'Valor em KM': {
          field: 'rec_km',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        Outros: {
          field: 'rec_captura_manual',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'Valor Uso Wallet': {
          field: 'rec_carteira',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'Receita com Locações': {
          field: 'total',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'Estornos Anteriores': {
          field: 'vlr_estorno',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'Reembolso Multa de Trans': {
          field: 'rec_multa_transito',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'Reembolso Sinistro': {
          field: 'rec_sinistro',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
      },
      fullScreen: false,
      transactionController: new TransactionController(this.$resource),
    };
  },
  created() {
    this.filtrar();
  },
  methods: {
    filtrar() {
      this.validateDate(this.initialDate);
      this.validateDate(this.finalDate);
      this.validateHour(this.initialHour);
      this.validateHour(this.finalHour);

      this.initialDateTime = `${format(this.initialDate, 'YYYY-MM-DD')} ${
        this.initialHour
      }`;
      this.finalDateTime = `${format(this.finalDate, 'YYYY-MM-DD')} ${
        this.finalHour
      }`;

      this.loadData(this.initialDateTime, this.finalDateTime);
    },

    async loadData(begin_date, end_date) {
      console.log(begin_date, end_date);
      this.blockScreen = true;
      try {
        let response = null;
        if (this.profile == Roles.Tcs) {
          response = await this.transactionController.getDetailedBillingReport(
            begin_date,
            end_date
          );
        }
        if (response.ok) {
          this.reservationGrid = response.data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.blockScreen = false;
      }
    },
    validateDate(date) {
      let timestamp = Date.parse(date);
      let day = new Date(timestamp).getDate();
      let month = new Date(timestamp).getMonth() + 1; // Os meses em JavaScript são indexados de 0 a 11

      if (!isNaN(timestamp)) {
        if (day < 1 && day > 31 && month < 1 && month > 12) {
          this.$awn.alert('A data é inválida.');
        }
      } else {
        this.$awn.alert('A data é inválida.');
      }
    },

    validateHour(hour) {
      // Expressão regular para validar o formato HH:MM:SS
      var regexHora = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

      // Verificar se a hora não corresponde ao formato esperado
      if (!regexHora.test(hour)) {
        this.$awn.alert('A hora é inválida.');
      }
    },

    formatValue(value) {
      let valorFloat = parseFloat(value);
      let formatado = 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
      return formatado;
    },

    setFullScreen() {
      if (!this.fullScreen) {
        document.getElementById('content').classList.add('full-screen');
        document.getElementById('table').classList.add('table-full-screen');
      } else {
        document.getElementById('content').classList.remove('full-screen');
        document.getElementById('table').classList.remove('table-full-screen');
      }
      this.fullScreen = !this.fullScreen;
    },
  },
  filters: {
    formatValue(value) {
      let valorFloat = parseFloat(value);
      let formatado = 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
      return formatado;
    },
  },
};
</script>

<style lang="scss">
.action-list button {
  float: right;
}
.table-custom-vue {
  margin: 20px;
}
.filtro-button {
  background: var(--primary-color-hover) !important;
}
.full-screen {
  width: 100vw;
  height: 100vh;
  padding: 0 !important;
  z-index: 7;
  position: absolute;
  top: 0;
  margin: 0;
}
.table-full-screen {
  height: 100vh;
  .v-data-table__wrapper {
    background: white;
  }
  .v-data-footer {
    background: white;
  }
}
</style>
